import { render, staticRenderFns } from "./ProgramSupportKitList.vue?vue&type=template&id=1ff896d7"
import script from "./ProgramSupportKitList.vue?vue&type=script&lang=ts"
export * from "./ProgramSupportKitList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports